import React from "react";

/**
 * Tracks how long a form has been on screen.
 * - `loadedAt`: timestamp of mount
 * - `elapsedMs()`: ms since mount (call at submit time)
 *
 * Used for spam filtering (sub-2s = bot) and engagement scoring
 * (longer thoughtful completions → higher lead score on the server).
 */
export function useFormTimer() {
  const loadedAt = React.useRef(Date.now()).current;
  const elapsedMs = React.useCallback(() => Date.now() - loadedAt, [loadedAt]);
  return { loadedAt, elapsedMs };
}
